import { get } from '../../api-config';
import { gdpService } from './_service';

export const getWidgets = async () => await get(gdpService, '/dashboard/widgets', null, null);
export const getDashboard = (params: any) => get(gdpService, `/dashboard`, null, params);
